import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;

import DurationSelect from "components/Pages/Finance/DurationSelect";
import Apy from "components/Pages/Finance/_cmpt/Apy";
import Countdown from "components/Pages/Finance/_cmpt/Countdown";
import BtnSubscribe from "components/Pages/Finance/_cmpt/BtnSubscribe";
import useCountdown from "components/Pages/Finance/_hook/useCountdown";
import useProductName from "components/Pages/Finance/_hook/useProductName";
import useProductChange from "components/Pages/Finance/_hook/useProductChange";
import getProductDefaultSelect from "components/Pages/Finance/_hook/getProductDefaultSelect";
import useGetProductById from "@/components/Pages/Finance/_hook/useGetProductById";

import Tag from "components/Pages/Finance/_cmpt/TagBeginner";
import cx from "classnames";
import stylesProducts from "@/components/Pages/Finance/Styles/products.module.less";
import stylesH5 from "@/components/Pages/Finance/Styles/h5.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

export default observer(({ data: category, rowCls }) => {
  const t = useTranslation();
  const { finance } = useStore();

  const [financialProducts, setFinancialProducts] = useState(category.financialProducts);
  useEffect(() => {
    setFinancialProducts(category.financialProducts);
  }, [category]);

  const [selectProduct, setSelectProduct] = useState(getProductDefaultSelect(financialProducts));
  useEffect(() => {
    setSelectProduct(getProductDefaultSelect(financialProducts));
  }, [category]);

  const productName = useProductName(selectProduct);
  const destTimestamp = useCountdown(selectProduct);

  const onFinancialProductsChange = (newFinancialProducts) => {
    setFinancialProducts(newFinancialProducts);
    for (let i in newFinancialProducts) {
      if (newFinancialProducts[i].id == selectProduct.id) setSelectProduct(newFinancialProducts[i]);
    }
  };

  const btnData = useMemo(() => {
    return {
      productId: selectProduct.id,
      financialProducts: financialProducts,
      callback: onFinancialProductsChange,
    };
  }, [financialProducts, selectProduct]);

  const onChange = useProductChange(setSelectProduct);

  const countdownCallbackFun = useGetProductById(({ err, data }) => {
    if (err) return;
    const index = financialProducts.findIndex((obj) => obj.id === data.id);
    if (index < 0) return;
    const newFinancialProducts = financialProducts
      .slice(0, index)
      .concat([data])
      .concat(financialProducts.slice(index + 1));
    onFinancialProductsChange(newFinancialProducts);
  });
  const countdownCallback = () => countdownCallbackFun(selectProduct);

  return (
    <div className={cx(stylesH5.card, rowCls)}>
      <div>
        <div>
          <span>{t("finance.PoSStaking")}</span>
          <Tag data={selectProduct} />
        </div>
        <Apy data={selectProduct} className={stylesProducts.apy} />
      </div>
      <div>
        <DurationSelect financialProducts={financialProducts} currentProduct={selectProduct} onChange={onChange} />
      </div>
      <div>
        <BtnSubscribe data={btnData} className={stylesProducts.btn} />
        <div>
          <Countdown
            style={{ marginTop: "3px" }}
            key={selectProduct.id + "-" + destTimestamp}
            data={destTimestamp}
            isHideExpired
            isSimple
            callback={countdownCallback}
          />
        </div>
      </div>
    </div>
  );
});
